import Vue from 'vue'
import App from './App.vue'
import store from './store/'
import './registerServiceWorker'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/firestore'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { version } from '../package.json'
import 'autotrack'

// Font-awesome
// https://www.npmjs.com/package/@fortawesome/vue-fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// Add more icons below
import { faTrash, faMapMarkedAlt, faChargingStation, faRoute, faQuestionCircle, faListUl, faLayerGroup } from '@fortawesome/free-solid-svg-icons'
import { faCalendarPlus } from '@fortawesome/free-regular-svg-icons'

library.add(faTrash)
library.add(faMapMarkedAlt)
library.add(faChargingStation)
library.add(faRoute)
library.add(faQuestionCircle)
library.add(faListUl)
library.add(faCalendarPlus)
library.add(faLayerGroup)
Vue.component('font-awesome-icon', FontAwesomeIcon)
// <font-awesome-icon
//       icon="question-cirle"/>

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyCnI1j48MVMsZKXA7rUlwJ3WQaI_ycK0AY',
  authDomain: 'evgo-39247.firebaseapp.com',
  databaseURL: 'https://evgo-39247.firebaseio.com',
  projectId: 'evgo-39247',
  storageBucket: 'evgo-39247.appspot.com',
  messagingSenderId: '447985462532'
}
firebase.initializeApp(config)
export const db = firebase.firestore()
db.settings({ timestampsInSnapshots: true })

Vue.config.productionTip = false
console.log('Version:', version)

// Bootstrap-vue
// https://bootstrap-vue.js.org/docs
Vue.use(BootstrapVue)

// Google analytics autotrack
// https://github.com/googleanalytics/autotrack
if (document.location.hostname === 'localhost' || document.location.hostname === 'hiko-dev2.firebaseapp.com' || document.location.hostname === '192.168.178.82') {
  console.log('Deveopment server - not submitting google analytics')
} else {
  window.ga = window.ga || function () { (ga.q = ga.q || []).push(arguments) }; ga.l = +new Date()
  ga('create', 'UA-40923812-2', 'auto')

  // Replace the following lines with the plugins you want to use.
  ga('require', 'eventTracker')
  ga('require', 'outboundLinkTracker')
  ga('require', 'urlChangeTracker')

  ga('send', 'pageview')
}

Vue.use(store)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
